import { useState } from "react";
import { Card } from "../../components/common/Card";
import { Toggle } from "../../components/common/Toggle";
import { getQrPreferences, setQrPreference } from "../../services/qrPreferences";

/**
 * Reached at /settings/qr, which the print warning links to directly so a
 * long-term user can turn it off from the prompt rather than hunting for it.
 */
export function QrLabelsTab() {
  const [prefs, setPrefs] = useState(getQrPreferences);

  function update(name, value) {
    setPrefs(setQrPreference(name, value));
  }

  return (
    <div>
      <Card title="Safety prompts">
        <Toggle
          id="qr-print-warning"
          label="Show placement warning before printing QR labels"
          checked={prefs.showPrintWarning}
          onChange={(v) => update("showPrintWarning", v)}
        />
        <p style={{ color: "var(--color-text-muted)", marginTop: "var(--space-2)" }}>
          The warning covers weatherproofing and what to do if a label looks
          wrong. Turning it off skips straight to the print dialog. This is a
          reminder only — it is stored in this browser and does not change who
          can read your hive data.
        </p>
      </Card>

      <Card title="What a QR label contains" className="section-spacing">
        <p style={{ color: "var(--color-text-muted)" }}>
          A hive label holds a hive reference and nothing else — no password,
          no access token, no location. Scanning one does nothing unless you
          are already signed in to an account with access to that hive, so a
          label that is photographed, lost, or left on a hive over winter
          cannot be used to read your data.
        </p>
        <p style={{ color: "var(--color-text-muted)", marginTop: "var(--space-2)" }}>
          The risk worth remembering is the opposite one: a label that has been
          swapped or moved points at the <em>wrong</em> hive, so records can end
          up on the wrong colony. Every label prints its hive number in plain
          text beside the code — check that it matches the hive in front of you
          before recording anything.
        </p>
      </Card>
    </div>
  );
}
